import { render, staticRenderFns } from "./RoleAdd.vue?vue&type=template&id=0a7fc7b0&scoped=true"
import script from "./RoleAdd.vue?vue&type=script&lang=js"
export * from "./RoleAdd.vue?vue&type=script&lang=js"
import style0 from "./RoleAdd.vue?vue&type=style&index=0&id=0a7fc7b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7fc7b0",
  null
  
)

export default component.exports